module.exports = __webpack_public_path__ + "img/rat.0e6cee9c.svg";